import React from "react";

function Result() {
  return <div>검색 결과 페이지</div>;
}

export default Result;
